"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EBlockchainName;
(function (EBlockchainName) {
    EBlockchainName["TEZOS"] = "TEZOS";
    EBlockchainName["TEZOS_GHOSTNET"] = "TEZOS_GHOSTNET";
    EBlockchainName["TEZOS_MAINNET"] = "TEZOS_MAINNET";
    EBlockchainName["BITCOIN_SIGNET"] = "BITCOIN_SIGNET";
    EBlockchainName["BITCOIN_MAINNET"] = "BITCOIN_MAINNET";
})(EBlockchainName || (EBlockchainName = {}));
exports.default = EBlockchainName;
